/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AttributeValueForDateTime extends models.AttributeValueBase {
    constructor() {
        super();
        this.setDiscriminator("AttributeValueForDateTime");
    }

    getFixupPrototypeFunction() { return AttributeValueForDateTime.fixupPrototype; }

    static newInstance(model: Partial<AttributeValueForDateTime>): AttributeValueForDateTime {
        let obj = Object.assign(new AttributeValueForDateTime(), model);
        AttributeValueForDateTime.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AttributeValueForDateTime>): AttributeValueForDateTime {
        if (!model) return null;
        return AttributeValueForDateTime.newInstance(<AttributeValueForDateTime> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AttributeValueForDateTime) {
        if (!obj) return;

        models.AttributeValueForDateTime.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AttributeValueForDateTime): boolean {
        if (models.AttributeValueBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, AttributeValueForDateTime.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (typeof this.value === "string") {
            this.value = new Date(<string><any>this.value);
        }
    }

    /**
     * Value for the Attribute
     */
    value: Date;

}
